export const colors = {
  primary: '#00BFA5',
  secondary: '#FFFFFF',
  danger: '#FF4757',
  background: '#F5F5F5',
  text: '#333',
  textLight: '#666',
  textGray: '#999',
  border: '#eee',
  infoBg: '#f9f9f9'
};
